<div class="mbm-form-group-column">
  @if (labelKey()) {
    <ion-label class="mbm-form-label">
      {{ labelKey()! | translate }}
      @if (isRequired()) {
        <img class="mbm-required-indicator" src="assets/icons/asterisk.svg" alt="" aria-hidden="true">
      }
    </ion-label>
  }
  <div class="mbm-form-field-wrapper mbm-textarea-field" [class.mbm-form-field-wrapper-error]="errorMessage()">
    <ion-textarea class="mbm-textarea-input" [value]="internalValue()" [disabled]="isDisabled()"
      [placeholder]="placeholderKey() ? (placeholderKey()! | translate) : ''"
      (ionInput)="onInput($event)" (ionBlur)="onBlur()">
    </ion-textarea>
    @if (actionIconSrc()) {
      <button class="mbm-textarea-action" type="button" [disabled]="isDisabled()" (click)="onActionClick()">
        <img class="mbm-textarea-action-icon" [src]="actionIconSrc()!" alt="" aria-hidden="true">
      </button>
    }
  </div>
  <mbm-form-error [message]="errorMessage()"></mbm-form-error>
</div>
